import { getCouncilData, getQldCouncilGeo } from '../api';

const fetchCouncilData = () => {
  return dispatch => {
    dispatch({ type: 'COUNCILS_QLD_GEO:REQUEST' });
    return getCouncilData()
      .then(response => {
        dispatch({ type: 'COUNCILS_DATA:SUCCESS', payload: response });
      })
      .catch(err => {
        dispatch({ type: 'COUNCILS_DATA:ERROR', payload: err });
      });
  };
};

const fetchQldCouncilGeo = () => {
  return dispatch => {
    dispatch({ type: 'COUNCILS_QLD_GEO:REQUEST' });
    return getQldCouncilGeo()
      .then(response => {
        dispatch({ type: 'COUNCILS_QLD_GEO:SUCCESS', payload: response });
      })
      .catch(err => {
        dispatch({ type: 'COUNCILS_QLD_GEO:ERROR', payload: err });
      });
  };
};

export const fetchCouncils = () => {
  return dispatch => {
    dispatch({ type: 'COUNCILS_ALL:REQUEST' });
    return Promise.all([
      dispatch(fetchCouncilData()),
      dispatch(fetchQldCouncilGeo()),
    ])
      .then(() => {
        dispatch({ type: 'COUNCILS_ALL:SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'COUNCILS_ALL:ERROR', payload: err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/councils.js